import { applicationTitleHolderApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TITLE_HOLDERS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/titleHolders`,
  {
    GET_TITLE_HOLDERS: 'GET_TITLE_HOLDERS',
    EDIT_TITLE_HOLDER: 'EDIT_TITLE_HOLDER',
    CREATE_TITLE_HOLDER: 'CREATE_TITLE_HOLDER',
    DELETE_TITLE_HOLDER: 'DELETE_TITLE_HOLDER',
  },
);

const titleHolderSchema = new schema.Entity('data', {}, { idAttribute: 'titleHolderId' });

export const getLoanTitleHoldersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationTitleHolderApi.getTitleHolders(params);

  return dispatch({
    type: TITLE_HOLDERS_ACTION_TYPE.GET_TITLE_HOLDERS,
    payload: normalize(data, [titleHolderSchema]).entities.data,
  });
});

export const editLoanTitleHolderAction = params => async dispatch => {
  const { data } = await applicationTitleHolderApi.editTitleHolder(params);

  return dispatch({
    type: TITLE_HOLDERS_ACTION_TYPE.EDIT_TITLE_HOLDER,
    payload: data,
  });
};

export const createLoanTitleHolderAction = params => async dispatch => {
  const { data } = await applicationTitleHolderApi.createTitleHolder(params);

  return dispatch({
    type: TITLE_HOLDERS_ACTION_TYPE.CREATE_TITLE_HOLDER,
    payload: data,
  });
};

export const deleteLoanTitleHolderAction = params => async dispatch => {
  await applicationTitleHolderApi.deleteTitleHolder(params);

  return dispatch({
    type: TITLE_HOLDERS_ACTION_TYPE.DELETE_TITLE_HOLDER,
    meta: params,
  });
};
